export default __webpack_public_path__ + "static/media/logoCE.d8449050.svg";